import { Empty } from 'antd'
import React from 'react'
import styles from "./emptyTblContainer.module.css"

export const EmptyTblContainer = ({ description }: { description: string }) => {
    return (
        <div className={styles.emptyState}>
            <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={description}
            />
        </div>
    )
}
